(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    let shippingInfoEscape = false;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = document.querySelector('.karnivor-shipping-info__panel:popover-open');
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    shippingInfoEscape = true;
    panel.hidePopover();
    document.querySelector('[popovertarget="' + panel.id + '"]')?.focus();
  }, true);
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape' || !shippingInfoEscape) return;
    shippingInfoEscape = false;
    event.stopImmediatePropagation();
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["karnivor-cart-discount"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('karnivor-cart-discount')) {
    class KarnivorCartDiscount extends HTMLElement {
      static busy = false;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('change', (event) => event.stopPropagation());
        this.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.updateDiscount(this.querySelector('input').value.trim(), false);
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-remove-code]');
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          this.updateDiscount(button.dataset.removeCode, true);
        });
        this.syncCodes();
      }

      normalize(code) {
        return String(code).trim().toLowerCase();
      }

      allocations(cart) {
        return [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.items || []).flatMap((item) =>
            (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)
          )
        ].filter(Boolean);
      }

      acceptedCodes(cart) {
        const values = Array.isArray(cart.discount_codes)
          ? cart.discount_codes.filter((discount) => discount.applicable === true).map((discount) => discount.code)
          : this.allocations(cart).filter((discount) => discount.type === 'discount_code').map((discount) => discount.title);
        return Array.from(new Map(values.map((code) => [this.normalize(code), code])).values());
      }

      async readCart() {
        const response = await fetch(this.dataset.cartUrl + '.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      }

      async syncCodes() {
        try {
          const cart = await this.readCart();
          if (this.isConnected && !KarnivorCartDiscount.busy) this.renderCodes(cart);
        } catch {}
      }

      renderCodes(cart) {
        const list = this.querySelector('.karnivor-cart-discount__codes');
        const codes = this.acceptedCodes(cart);
        list.replaceChildren();
        for (const code of codes) {
          const pill = document.createElement('li');
          pill.className = 'karnivor-cart-discount__code';
          pill.dataset.discountCode = code;
          const check = document.createElement('span');
          check.className = 'karnivor-cart-discount__check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          const value = document.createElement('span');
          value.className = 'karnivor-cart-discount__value';
          value.textContent = code;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'karnivor-cart-discount__remove';
          button.dataset.removeCode = code;
          button.setAttribute('aria-label', this.dataset.removeLabel.replace('[code]', code));
          const cross = document.createElement('span');
          cross.setAttribute('aria-hidden', 'true');
          cross.textContent = '×';
          button.append(cross);
          pill.append(check, value, button);
          list.append(pill);
        }
        list.hidden = codes.length === 0;
      }

      feedback(key, error = false) {
        const input = this.querySelector('input');
        const errorElement = this.querySelector('.karnivor-cart-discount__error');
        const status = this.querySelector('.karnivor-cart-discount__status');
        errorElement.hidden = true;
        status.hidden = true;
        input.removeAttribute('aria-invalid');
        if (!key) return;
        const tools = this.closest('karnivor-cart-tools');
        if (tools) tools.setOpen(tools.querySelector('#CartDrawer-DiscountToggle'));
        const target = error ? errorElement : status;
        target.textContent = this.dataset[key];
        target.hidden = false;
        if (error) input.setAttribute('aria-invalid', 'true');
      }

      async requestUpdate(codes, sections) {
        const response = await fetch(this.dataset.updateUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: codes.join(','),
            sections,
            sections_url: window.location.pathname + window.location.search
          })
        });
        const cart = await response.json();
        if (!response.ok || cart.errors || cart.status >= 400) throw new Error('Discount update failed');
        return cart;
      }

      async renderCart(cart, drawer, mainCart, sectionIds) {
        if (sectionIds.some((id) => typeof cart.sections?.[id] !== 'string')) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sectionIds.join(','));
          const response = await fetch(url, { cache: 'no-store' });
          if (!response.ok) throw new Error('Section refresh failed');
          cart.sections = await response.json();
        }
        if (sectionIds.some((id) => typeof cart.sections?.[id] !== 'string')) {
          throw new Error('Section unavailable');
        }
        drawer.renderContents(cart, true);
        if (mainCart) mainCart.renderContents(cart, mainCart.getSectionsToRender());
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
        }
        return drawer.querySelector('karnivor-cart-discount');
      }

      async updateDiscount(code, removing) {
        if (KarnivorCartDiscount.busy || !code) return;
        if (code.includes(',')) {
          this.feedback('invalid', true);
          return;
        }
        const drawer = this.closest('cart-drawer');
        if (!drawer) return;
        KarnivorCartDiscount.busy = true;
        this.feedback();
        this.setAttribute('aria-busy', 'true');
        const enabledControls = [...drawer.querySelectorAll('input, button, select, textarea')]
          .filter((control) => !control.disabled && !control.matches('.drawer__close'));
        enabledControls.forEach((control) => { control.disabled = true; });
        this.querySelector('.karnivor-cart-discount__apply').textContent = this.dataset.loading;
        let target = this;

        try {
          const current = await this.readCart();
          const previousCodes = this.acceptedCodes(current);
          const sameCode = (value) => this.normalize(value) === this.normalize(code);
          if (!removing && previousCodes.some(sameCode)) {
            this.feedback('duplicate');
            return;
          }
          const desired = removing ? previousCodes.filter((value) => !sameCode(value)) : [...previousCodes, code];
          const mainCart = document.querySelector('cart-items');
          const sectionIds = [...new Set([
            ...drawer.getSectionsToRender().map((section) => section.id),
            ...(mainCart ? mainCart.getSectionsToRender().map((section) => section.section) : [])
          ])].slice(0, 5);
          let cart = await this.requestUpdate(desired, sectionIds);
          const accepted = this.acceptedCodes(cart).some(sameCode);
          const invalid = !removing && !accepted;
          if (invalid) cart = await this.requestUpdate(previousCodes, sectionIds);
          if (removing && accepted) throw new Error('Code still present');

          target = await this.renderCart(cart, drawer, mainCart, sectionIds) || this;
          target.renderCodes(cart);
          target.querySelector('input').value = invalid ? code : '';
          target.feedback(invalid ? 'invalid' : removing ? 'removed' : 'applied', invalid);
          if (drawer.classList.contains('active')) {
            const input = target.querySelector('input');
            if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), input);
            else input.focus();
          }
        } catch {
          target = drawer.querySelector('karnivor-cart-discount') || this;
          target.feedback('error', true);
        } finally {
          enabledControls.forEach((control) => { if (control.isConnected) control.disabled = false; });
          this.removeAttribute('aria-busy');
          this.querySelector('.karnivor-cart-discount__apply').textContent = this.dataset.apply;
          KarnivorCartDiscount.busy = false;
        }
      }
    }
    customElements.define('karnivor-cart-discount', KarnivorCartDiscount);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["karnivor-cart-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('karnivor-cart-tools')) {
    customElements.define('karnivor-cart-tools', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.karnivor-cart-tools__button');
          if (!button || !this.contains(button)) return;
          this.setOpen(button.getAttribute('aria-expanded') === 'true' ? null : button);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const button = this.querySelector('[aria-expanded="true"]');
          if (!button) return;
          event.preventDefault();
          event.stopPropagation();
          this.setOpen(null);
          button.focus();
        });
      }
      setOpen(activeButton) {
        for (const button of this.querySelectorAll('.karnivor-cart-tools__button')) {
          const expanded = button === activeButton;
          button.setAttribute('aria-expanded', String(expanded));
          const panel = this.querySelector('#' + button.getAttribute('aria-controls'));
          if (panel) panel.hidden = !expanded;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
